import * as actionTypes from './actionTypes'
import config from './config'

export default {actionTypes, config}
